import { commonDataReducer } from './CommonData.slice';

export const getCommonDataModule = () => ({
  id: 'CommonDataModule',
  reducerMap: {
    commonData: commonDataReducer,
  },
  sagas: [],
});
